export default "__VITE_ASSET__vYw8SbTu__"